import { render, staticRenderFns } from "./CourseCertificatesPage.vue?vue&type=template&id=3360e664&"
import script from "./CourseCertificatesPage.vue?vue&type=script&lang=ts&"
export * from "./CourseCertificatesPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports